import Routes from "./routes/ProjectRoutes"
import "./App.scss"
function App() {
  return (
    <Routes />
  )
}

export default App;